<script setup lang="ts">

import { computed } from "vue";
const props = defineProps<{ items: any }>()

const handledItems = computed(()=>{
  const arrItems = props.items;


  const newItems = [] as any

  arrItems.sort((a, b) => a.article.type.localeCompare(b.article.type));
  arrItems.forEach(x=>{
    
   
        newItems.push({count:x.count, text:x.article.tagTitle, measure:x.article.measure?.shortTitle?x.article.measure?.shortTitle:''})
      
   
    
  })
  return newItems
})
</script>

<template>
  <div v-if="handledItems && handledItems.length" class="complect-wrapper"> 
  
    <template v-for="item in handledItems" :key="item.text">
      <div v-if="!item.text.includes('фахверк') && !item.text.includes('профиль')" class="complect-text-row"><span class="key-complect-text">{{item.text}}</span> <div class="complect-sep"></div> <span class="value-complect-text">{{`${item.count} ${item.measure}.`}}</span></div> 
    </template>

  </div>
</template>

<style scoped>

.value-complect-text{
  white-space: nowrap;
  color:#2C2C2C;
font-weight: 400;
font-size: 10px;
line-height: 120%;
letter-spacing: 0%;
text-align: right;

}
.key-complect-text{
color:#2C2C2C;
font-weight: 400;
font-size: 10px;
line-height: 120%;
letter-spacing: 0%;

}
.complect-wrapper{
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 66px;
  overflow: hidden;
}
  .complect-text-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    text-align: start;
    align-items: flex-end;
  }
  .complect-sep{



    flex-grow: 1;
    border-bottom: 1px dashed #EDEDED;
    height: 1px;
    margin-bottom: 1px;
  }
</style>
